import script from "./OsterFooterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OsterFooterComponent.vue?vue&type=script&setup=true&lang=js"

import "./OsterFooterComponent.vue?vue&type=style&index=0&id=654a761c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-654a761c"]])

export default __exports__